import { Button } from 'antd';
import styled from '@emotion/styled';

export const StyledEllipsisButton = styled(Button)`
    border-radius: 6px !important;
    overflow: hidden;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border: 1px solid #d9d9d9 !important;

    &:hover:not(:disabled) {
        color: var(--ant-primary-color-hover) !important;
        border-color: var(--ant-primary-color-hover) !important;
    }

    &:focus:not(:disabled) {
        color: var(--ant-primary-color-hover) !important;
        border-color: var(--ant-primary-color-hover) !important;
    }

    .anticon {
        color: inherit;
    }
`;
